import { Navigate, Outlet, useLocation } from 'react-router';

import { PageLoader } from '../components/ui/Loader';
import { paths } from '../config/paths';
import { useI18n } from '../i18n/I18nProvider';
import { useAuth } from './AuthProvider';

export function ProtectedRoute() {
  const { session, loading } = useAuth();
  const { t } = useI18n();
  const location = useLocation();

  if (loading) {
    return <PageLoader label={t('loading')} />;
  }

  if (!session) {
    const returnTo = `${location.pathname}${location.search}`;
    return <Navigate to={paths.auth.signIn.getHref(returnTo)} replace />;
  }

  return <Outlet />;
}
